// Route path constants
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  APPLICATION: '/application',
  NOT_FOUND: '/404',
  ORY_CALLBACK: '/auth/callback',
  ACCOUNT_SETTINGS: '/account/settings',
  ACCOUNT_MANAGE: '/account/manage',
  ADMIN_SETTINGS: '/admin/settings',
  RECOVERY: '/recovery',
  VERIFICATION: '/verification',
} as const;

export const PUBLIC_ROUTES = [
  ROUTES.HOME,
  ROUTES.LOGIN,
  ROUTES.REGISTER,
  ROUTES.APPLICATION,
  ROUTES.ORY_CALLBACK,
  ROUTES.RECOVERY,
  ROUTES.VERIFICATION,
];
export const PRIVATE_ROUTES = [
  ROUTES.DASHBOARD,
  ROUTES.PROFILE,
  ROUTES.ACCOUNT_SETTINGS,
  ROUTES.ACCOUNT_MANAGE,
];
export const ADMIN_ROUTES = [ROUTES.ADMIN_SETTINGS];
